import { createFileRoute, notFound } from "@tanstack/react-router";
import shopStyles from "../styles/shop.css?url";
import { OrderPage } from "../components/shop/order-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadOrderPage } from "../server/shop";

/**
 * An order (/merch/orders/:id). The buyer's browser asks for it with the token it kept at
 * checkout or the key in their order email; the page itself holds nothing about it.
 */
export const Route = createFileRoute("/merch/orders/$id")({
  loader: async () => {
    const page = await loadOrderPage({ data: "order" });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData, params }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = withStylesheet(
      creatorPageHead(shell, {
        pathname: `/merch/orders/${params.id}`,
        title: `Your order | ${loaderData.creatorName}`,
        description: shell.creator.description,
        noindex: true,
      }),
      shopStyles,
    );
    return { ...head, meta: [...(head.meta ?? []), { name: "referrer", content: "no-referrer" }] };
  },
  component: Order,
});

function Order() {
  const { id } = Route.useParams();
  return <OrderPage key={id} id={id} />;
}
